
import * as React from 'react';

import { useHistory, useLocation } from 'react-router-dom';

import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import ApartmentIcon from '@mui/icons-material/Apartment';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import axios from 'axios';
// import Cookies from 'universal-cookie';
import Config from '../../config';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { COMMON_PROPERTY } from '../../store/property/common/commonProperty.reducer';
import { useDispatch } from 'react-redux';
import { SET_FORCE_LOGOUT_VAR } from '../../store/property/common/commonProperty.actionsType';


import superAdmin from '../../menu-items-admin'
import { initialLoadCommon } from '../../App/components/Common/Util';


const theme = createTheme();


export default function LoginCompany() {

    const location = useLocation();
    const companies = location.state?.companies || [];
    const handleCompanyClick = (company) => {
        Cookies.set('JWT_TOKEN', company.fldToken);
        Cookies.set('COMPANY_CODE', company.fldCompanyCode);


        const config = {
            headers: {
                Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                'Access-Control-Allow-Origin': true,
                'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                'Content-Type': 'application/json',
                dbname: Cookies.get('DATABASE')
            }
        }

        axios
            .get(`${Config.baseUrl}/api/TblDashboard/GetUserProfile`, config)
            .then((profileRes) => {
                Cookies.set('USER', JSON.stringify(profileRes.data));
                history.push('/bulk/dashboard');
                setLoading(false);
                initialLoadCommon(dispatch)

                if (profileRes.data.fldRole === 'Super Admin') {
                    localStorage.setItem('MENUS', JSON.stringify(superAdmin));
                } else {
                    getUsersMenu();
                }
            }).catch((profileErr) => {
                toast.error(profileErr?.response?.data);
            })

            .catch((loginErr) => {
                toast.error(loginErr?.response?.data);
                setLoading(false);
                if (loginErr?.response?.data?.status === 401) {
                    toast.error('Invalid Credentials');
                }
                if (loginErr?.response?.data === 'User already logged in') {
                    dispatch({ type: SET_FORCE_LOGOUT_VAR, payload: true });
                } else {
                    dispatch({ type: SET_FORCE_LOGOUT_VAR, payload: false });
                }
            });



    };

    const getUsersMenu = () => {
        const config = {
            headers: {
                Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                'Access-Control-Allow-Origin': true,
                'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                'Content-Type': 'application/json',
                dbname: Cookies.get('DATABASE')
            }
        };
        axios
            .get(`${Config.baseUrl}/api/TblDashboard/GetUsersMenu`, config).then((res) => {
                localStorage.setItem('MENUS', JSON.stringify(res.data));
                setTimeout(() => {
                    window.location.reload(true);
                }, 100)

            }).catch((err) => {
                toast.error(err?.response?.data);
            });
    }




    const [loading, setLoading] = React.useState(false)
    let history = useHistory();
    let dispatch = useDispatch();


    return (
        <ThemeProvider theme={theme}>
            <Container
                component="main"
                // @ts-ignore
                maxWidth="vw"
                // height = '100vh'
                sx={{
                    background: 'linear-gradient(130deg, #feedd3, #9dc9f6)',
                    height: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <CssBaseline />
                <Box
                    sx={{
                        flexDirection: 'column',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100vh',
                        width: '100%'
                    }}
                >
                    <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                        <ApartmentIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Select Your Company
                    </Typography>
                    <Box
                        component="form"
                        // onSubmit={handleSubmit}
                        sx={{
                            mt: 1,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexDirection: 'column',

                            minWidth: '30%',
                            maxWidth: '60%'
                        }}
                    >
                        <Grid container spacing={6} justifyContent="center">
                            {companies?.map((company) => (
                                <Grid item key={company.fldCode}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={(e) => handleCompanyClick(company)}
                                        sx={{
                                            width: '200px',
                                            height: '180px',
                                            borderRadius: '15px',
                                            backgroundColor: 'white',
                                            color: '#000',
                                            '&:hover': {
                                                background: 'linear-gradient(130deg, #feedd3, #9dc9f6)', // You can change hover color if needed
                                            }
                                        }}
                                    >
                                        {/* <Avatar
                                        src={company.logo}
                                        alt={company.name}
                                        sx={{ width: '100px', height: '100px', marginBottom: 10 }}
                                    /> <br/> */}
                                        <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '18px' }}>
                                            {company.fldCompanyName}
                                        </Typography>
                                    </Button>
                                </Grid>
                            ))}
                        </Grid>

                    </Box>
                </Box>
            </Container>
        </ThemeProvider>
    );
}
